// Business rules shared by API, web and (phase 2) mobile (constitution §3, plan §2).
export const APP_NAME = 'CIS Program Portal';

export * from './roles.ts';
export * from './task-state.ts';
export * from './sod.ts';
export * from './evidence-state.ts';
export * from './leads.ts';
export * from './time.ts';
